import { Translation } from '../types/i18n';

export const ko: Translation = {
  modeToggle: {
    cubeMode: '🧩 Cube Mode',
    speedcubing: '⏱️ Speedcubing',
    hint: '💡 Tab 키로 모드를 변경할 수 있습니다',
  },

  keyGuide: {
    title: '⌨️ Key Guide',
    open: '키 가이드 열기',
    close: '키 가이드 닫기',
    sections: {
      cubeControl: '🎮 큐브 조작',
      camera: '📹 카메라',
      system: '⚡ 시스템',
      controls: '🎛️ 조작',
    },
    keys: {
      frontRotate: 'Front 면 회전',
      upRotate: 'Up 면 회전',
      backRotate: 'Back 면 회전',
      leftRotate: 'Left 면 회전',
      downRotate: 'Down 면 회전',
      rightRotate: 'Right 면 회전',
      cubeTilt: '큐브 90도 회전',
      counterClockwise: '반시계방향 회전',
      counterClockwiseHint: '💡 예: Shift+Q = Front\' (반시계)',
      prevCorner: '이전 코너',
      nextCorner: '다음 코너',
      topView: 'Top View',
      timerStartStop: '타이머 시작/정지',
      modeSwitch: '모드 전환',
      shuffle: '큐브 셔플',
      reset: '큐브 리셋',
      undo: '실행 취소',
      redo: '다시 실행',
      speedDecrease: '애니메이션 속도 감소',
      speedIncrease: '애니메이션 속도 증가',
      zoomOut: '카메라 줌 축소',
      zoomIn: '카메라 줌 확대',
    },
    scrollHint: '↓ 더 많은 단축키 ↓',
  },

  historyBar: {
    clear: '히스토리 지우기',
    empty: '조작 히스토리가 없습니다',
  },

  rankingPanel: {
    title: '🏆 랭킹',
    open: '랭킹 패널 열기',
    close: '랭킹 패널 닫기',
    tabs: {
      all: '전체',
      my: '내 기록',
    },
    columns: {
      rank: '순위',
      nickname: '닉네임',
      time: '시간',
      moves: '이동',
      date: '날짜',
    },
    noRecords: '기록이 없습니다',
    loading: '기록을 불러오는 중...',
    error: '전체 랭킹을 불러오는데 실패했습니다.',
    retry: '재시도',
    refresh: '새로고침',
    stats: {
      totalRecords: '총 기록',
      bestRecord: '최고 기록',
      recordsUnit: '개',
    },
  },

  nicknameModal: {
    title: '큐브 완성!',
    subtitle: '기록을 랭킹에 등록하시겠습니까?',
    placeholder: '닉네임을 입력하세요 (2-20글자)',
    confirm: '저장',
    skip: '건너뛰기',
    saving: '저장 중...',
    errors: {
      required: '닉네임을 입력해주세요.',
      tooShort: '닉네임은 2글자 이상 입력해주세요.',
      tooLong: '닉네임은 20글자 이하로 입력해주세요.',
      invalidChars: '닉네임에는 특수문자를 사용할 수 없습니다.',
      saveFailed: '기록 저장 중 오류가 발생했습니다.',
      supabaseFailed: '온라인 랭킹 저장에 실패했지만, 내 기록에는 저장되었습니다.',
    },
    success: '✅ 기록이 성공적으로 저장되었습니다!',
    note: '⚠️ 기록은 내 기록과 전체 랭킹에 모두 저장됩니다.',
  },

  shuffleModal: {
    title: '🎲 큐브 섞기',
    message: '큐브를 섞으시겠습니까?',
    confirm: '섞기',
    cancel: '취소',
  },

  colorSettings: {
    title: '🎨 색상 설정',
    presets: '프리셋',
    custom: '커스텀',
    faces: {
      up: '위',
      right: '오른쪽',
      front: '앞',
      down: '아래',
      left: '왼쪽',
      back: '뒤',
    },
    apply: '적용',
    close: '닫기',
    presetNames: {
      standard: '표준',
      'high-contrast': '고대비',
      distinct: '구분 강화',
      vivid: '선명한 색상',
      matte: '매트 색상',
      classic: '클래식',
      retro: '레트로',
    },
    presetDescriptions: {
      standard: '기본 색상 설정',
      'high-contrast': '주황/빨강 구분 강화된 색상',
      distinct: '색상 구분이 어려운 사용자를 위한 조합',
      vivid: '모든 색상이 명확히 구분되는 조합',
      matte: '차분하면서도 구분 명확한 색상',
      classic: '전통적인 원색 조합',
      retro: '80년대 스타일의 명확한 색상',
    },
  },

  cameraMinimap: {
    title: '📹 Camera View',
    open: '카메라 패널 열기',
    close: '카메라 패널 닫기',
    speed: '⚡ Animation Speed',
    zoom: '🔍 Zoom',
    colors: '색상 설정',
    speedHint: '💡 애니메이션 속도를 낮추면 더빠르게 큐브를 조작할 수 있습니다',
    legend: {
      upper: 'Upper',
      lower: 'Lower',
      current: 'Current',
    },
    navigation: {
      title: 'Corner Navigation:',
      opposite: 'Opposite Corner',
      prev: 'Prev Corner',
      next: 'Next Corner',
      toggle: 'Toggle Level',
    },
  },

  speedHint: {
    title: 'Pro Tip',
    message: '애니메이션 속도를 낮추면 더 빠르게 조작할 수 있습니다',
    dismiss: '힌트 닫기',
  },

  timer: {
    ready: '준비!',
    locked: '🔒 큐브 잠김',
    inspection: '검사',
  },

  footer: {
    portfolio: 'Portfolio',
    github: 'Github',
    rights: '© 2025 Kuneosu. All rights reserved.',
  },

  languageDialog: {
    title: '언어 선택',
    subtitle: '사용할 언어를 선택해주세요',
    korean: '한국어',
    english: 'English',
  },
};
